import { render, staticRenderFns } from "./DockApp.vue?vue&type=template&id=cf16db4e&scoped=true&"
import script from "./DockApp.vue?vue&type=script&lang=js&"
export * from "./DockApp.vue?vue&type=script&lang=js&"
import style0 from "./DockApp.vue?vue&type=style&index=0&id=cf16db4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf16db4e",
  null
  
)

export default component.exports